'use client';

/**
 * useAuth.ts — offentlig hook for auth-state
 *
 * Tynn wrapper rundt useAuthContext() fra src/contexts/AuthContext.tsx.
 * Dette er den offentlige API-en komponenter bruker for å lese auth-state
 * og kalle login/logout.
 *
 * Returnerer:
 * - user: innlogget bruker (AuthUser | null)
 * - loading: true under initialisering
 * - login: (username, password, remember) => Promise<void>
 * - logout: () => void
 *
 * Bruk:
 *   const { user, loading, login, logout } = useAuth();
 *   if (loading) return <LoadingSpinner />;
 *   if (!user) return <Login />;
 */

import { useAuthContext } from '@/contexts/AuthContext';

export function useAuth() {
  return useAuthContext();
}
